import React, { Component } from 'react';
import moment from 'moment';
import { Modal, Button,Segment, Grid, Message } from 'semantic-ui-react';
import { BaseURLDev, headers } from '../../../../../_utils/config';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import { SingleDatePicker, isInclusivelyBeforeDay } from 'react-dates';
import swal from 'sweetalert';
import { isBank, isAdmin } from '../../../../../_utils/localstorage';


export default class DateModalVerif extends Component {

   constructor(props){
      super(props)
      this.state = {
         data: props.data_verif,
         date: null,
         requests: false
      }

      this.verifikasiSTS = this.verifikasiSTS.bind(this)
      
   }

    verifikasiSTS(){
         const date_manual = this.state.date===null ? null : this.state.date.format('YYYY-MM-DD')
         var data_send, text_send, url_send = null;
         
         if(date_manual === null){
            swal("Verifikasi STS", "Pilih tanggal", "error");
            return false;
         }

         if(isBank()){
            data_send = JSON.stringify({
               no_sts: this.state.data.no_sts,
               date: date_manual
            });
            text_send = "STS ini akan diverifikasi, dan langsung divalidasi ke server SIMDA!";
            url_send = `${BaseURLDev}/postsimda/verifikasi`;
         }

         if(isAdmin()){
            data_send = JSON.stringify({
               date: date_manual
            })
            text_send = "STS ini akan diverifikasi ulang, dan langsung divalidasi ke server SIMDA!"
            url_send = `${BaseURLDev}/postsimda/verifikasiadm/${this.state.data.public_id}`;
         }

        swal({
            title: "Apakah anda yakin?",
            text: text_send,
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
        .then((verif) => {
         if (verif) {
               this.setState({requests:true});
               fetch(url_send, {
                  method: 'POST',
                  headers,
                  body: data_send
               })
               .then(response => {
                  if (!response.ok) { 
                     this.setState({requests:false});
                     swal("Verifikasi STS gagal", {
                     icon: "error",
                     });
                     return Promise.reject(response.statusText);
                  }
                  return response.json()
               })
               .then(parsedJSON => {
                  this.setState({
                     data: {
                        ...this.state.data, is_verified: true
                     },
                     requests:false
                  });
                  swal("Verifikasi STS selesai", {
                     icon: "success",
                  }).then(() => {
                  if(isBank())
                     window.location.href="/c/realisasi"

                  else window.location.href="/a/sts"

                  });
               })
         } else {
               return false
         }
        });
    }

   render() {
      return (
         
         <div>
            <Modal
               open={this.props.open}
               onClose={this.props.onClose}
               closeOnEscape={false}
               closeOnRootNodeClick={false}
               size="tiny"
            >
               <Modal.Header>
                  Verifikasi
               </Modal.Header>
               
               <Modal.Content>
                  <Grid>
                     <Grid.Column width={16}>
                        {!this.state.requests ? 
                           <Segment>
                              <SingleDatePicker 
                                 date={this.state.date}
                                 block
                                 isOutsideRange={day => !isInclusivelyBeforeDay(day, moment())}
                                 onDateChange={(date) => this.setState({ date })}
                                 numberOfMonths={1}
                                 focused={this.state.focused}
                                 onFocusChange={({ focused }) => this.setState({ focused })}
                                 id="dateManual"
                                 onDatesChange={({ date }) => this.setState({ date })}
                              />
                              
                              <Message
                                 error
                                 header='** Penting!'
                                 content='Tanggal harus dipilih'
                              />
                           </Segment>
                        :
                           <Segment loading={this.state.requests} >
                              <Message
                                 error
                                 header='Loading...'
                                 content='Tunggu sebentar sedang diproses'
                              />
                           </Segment>
                        }
                     </Grid.Column>                        
                  </Grid>
               </Modal.Content>
               <Modal.Actions>
                  <Button disabled={this.state.requests} positive onClick={this.verifikasiSTS}>Verifikasi</Button>
                  <Button disabled={this.state.requests} negative onClick={this.props.onClose}>Tutup</Button>
               </Modal.Actions>
            </Modal>
         </div>
      );
   }
}


// WEBPACK FOOTER //
// ./src/components/Content/views/admin/_sts/DateModalVerif.js